import styled, {css} from "styled-components";

interface SelectProps {
	types?: "calendar" | "line";
	width?: number;
}

const SelectBox = styled.div<SelectProps>`
	position: relative;
	display: flex;
	width: 100%;
	height: 100%;
	padding: 7px 23px 7px 10px;
	border: 1px solid var(--line-color);
	background-color: #fff;
	cursor: pointer;
	align-items: center;
	box-sizing: border-box;

	&::before {
		position: absolute;
		right: 13px;
		width: 0px;
		height: 0px;
		border-left: 4px solid transparent;
		border-right: 4px solid transparent;
		border-top: 5px solid #222;
		content: "";
	}

	&:focus {
		border: 2px solid var(--emp-color);
	}

	${props => {
		if (props.types === "calendar") {
			return css`
				padding: 0;
				border: none;
				line-height: 1;

				label {
					margin: 0;
					font-size: 22px;
					font-weight: bold;
					color: #222;
					cursor: pointer;
				}

				&::before {
					right: 0;
				}
			`;
		}

		if (props.types === "line") {
			return css`
				position: relative;
				display: flex;
				width: 100%;
				height: 100%;
				padding: 0.5em 45px 0.5em 10px;
				border: 1px solid var(--line-color);
				align-items: center;
				box-sizing: border-box;
				cursor: pointer;

				&::before {
					position: absolute;
					right: 13px;
					width: 0px;
					height: 0px;
					border-left: 8px solid transparent;
					border-right: 8px solid transparent;
					border-top: 8px solid #222;
					content: "";
				}
				&:after {
					position: absolute;
					top: -1px;
					right: 0;
					width: 43px;
					height: 43px;
					border: 1px solid #bbb;
					content: "";
				}
			`;
		}
	}}
`;

const SelectLabel = styled.label<{isActive?: boolean}>`
	margin: 0 0 0 4px;
	font-size: ${props => (props.isActive ? "var(--medium-size)" : "var(--default-size)")};
	text-align: center;
`;

const SelectOptions = styled.ul<{search?: boolean}>`
	position: absolute;
	top: ${props => (props.search ? "43px" : "36px")};
	left: 0;
	width: 100%;
	height: auto;
	max-height: 380px;
	padding: 0;
	overflow: auto;
	border: 1px solid var(--line-color);
	background-color: #fff;
	z-index: 5;

	li {
		display: flex;
		min-height: 38px;
		padding: 0 10px 0 15px;
		align-items: center;
		cursor: pointer;

		&:hover {
			background-color: #f3f3f3;
		}
	}
`;

const SelectWrap = styled.div<{width?: number}>`
	position: relative;
	width: ${props => (props.width ? `${props.width}px` : "100%")};
`;

export {SelectBox, SelectLabel, SelectOptions, SelectWrap};
